import React, { useCallback, useMemo } from 'react';
import { Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Col, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import DateColumn from 'components/pages/sistema/dateColumn';

const HomeEvento = React.memo(({ data, isLojaEvento, isClienteMensal }) => {
  const navigate = useNavigate();

  const handleClick = useCallback((evento) => {
    if (isLojaEvento || isClienteMensal) {
      navigate(`/evento/dashboard/${evento.id}/${evento.lojaId}`);
    } else {
      navigate(`/evento/dashboard/${evento.id}`);
    }
  }, [navigate, isLojaEvento, isClienteMensal]);

  const createTooltip = useCallback((content) => (
    <Tooltip style={{ position: 'fixed' }}>
      {content}
    </Tooltip>
  ), []);

  const renderCard = useCallback((evento) => {
    const tooltipContent = `${evento.nome} - ${evento.local}`;
    const uniqueKey = `${evento.id}-${evento.lojaId || 'default'}`;

    return (
      <Col key={uniqueKey}>
        <Card className='overflow-hidden dashboard-card-shadow home-card'>
          <Card.Header className='evento-card-header'>
            <OverlayTrigger
              placement='top'
              overlay={createTooltip(tooltipContent)}
            >
              <h4 className='home-evento-card-title d-inline-block'>
                {`${evento.nome} ${evento.local}`}
              </h4>
            </OverlayTrigger>
            {isLojaEvento && (
              <OverlayTrigger
                placement='bottom'
                overlay={createTooltip(evento.lojaNome)}
              >
                <h5>{evento.lojaNome}</h5>
              </OverlayTrigger>
            )}
          </Card.Header>
          {!isClienteMensal && (
            <Card.Body className="position-relative evento-card-body">
              <h5>
                Data Início:
                <DateColumn date={evento.dataInicio} showTime />
              </h5>
              <h5>
                Data Termino:
                <DateColumn date={evento.dataTermino} showTime />
              </h5>
            </Card.Body>
          )}
          <Card.Footer className='evento-card-footer' onClick={() => handleClick(evento)}>
            <p>Acessar Dashboard</p>
          </Card.Footer>
        </Card>
      </Col>
    );
  }, [isLojaEvento, isClienteMensal, handleClick, createTooltip]);

  const renderedCards = useMemo(() => 
    data.map(renderCard), 
    [data, renderCard]
  );

  return (
    <Row className="g-3 mb-3 home-card-grid">
      {renderedCards}
    </Row>
  );
});

HomeEvento.displayName = 'HomeEvento';

export default HomeEvento;